import React from 'react';
import { Users } from 'lucide-react';

interface MobileParticipantsSidebarProps {
    participants: any[];
    renderParticipantCard: (participant: any) => React.ReactNode;
    onClose: () => void;
}

const MobileParticipantsSidebar: React.FC<MobileParticipantsSidebarProps> = ({
    participants,
    renderParticipantCard,
    onClose,
}) => {
    return (
        <div className="sm:hidden absolute inset-0 z-40 bg-gray-950/90 backdrop-blur-sm rounded-2xl">
            <div className="flex h-full flex-col">
                {/* Header */}
                <div className="flex items-center justify-between px-4 py-3 border-b border-white/10">
                    <h3 className="text-white font-semibold text-sm flex items-center gap-2">
                        <Users className="w-4 h-4" />
                        Participants ({participants.length})
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-white/60 hover:text-white p-1"
                    >
                        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>
                {/* Scrollable list */}
                <div
                    className="flex-1 overflow-y-auto p-3 space-y-2"
                    style={{ scrollbarWidth: 'thin', scrollbarColor: 'rgba(255,255,255,0.2) transparent' }}
                >
                    {participants.map(p => (
                        <div key={p.identity} className="aspect-video">
                            {renderParticipantCard(p)}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MobileParticipantsSidebar;
